import { Component } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { RouterLink } from "@angular/router";

@Component({
  selector: "app-logo-header",
  imports: [RouterLink],
  templateUrl: "./logo-header.component.html",
  styleUrl: "./logo-header.component.scss",
})
export class LogoHeaderComponent {
  assetUrl = environment.assetBaseUrl;
}
